import PageHeader from "components/page-header";
import MainLayout from "screens/partials/layout";

const BlankPage = () => {
    return (
        <MainLayout>
            <div>
                <PageHeader title="Blank Page"/>
            </div>
        </MainLayout>
    )
};

export default BlankPage;
